import { 
    RECEIVE_CURRENT_USER, 
    RECEIVE_USER_LOGOUT,
    RECEIVE_REFRESHED_SESSION
} from '../actions/session_actions';

import { UPDATE_USER_IMAGE } from '../actions/user_actions'
const initialState = {
    isAuthenticated: false,
    user: null,
    refreshTokenExp: null
};

export default function (state = initialState, action) {
    switch (action.type) {
        case RECEIVE_CURRENT_USER:
            return {
                ...state,
                isAuthenticated: !!action.currentUser,
                user: action.currentUser,
                refreshTokenExp: action.refreshTokenExp || null
            };
        case RECEIVE_REFRESHED_SESSION:
            return {
                ...state,
                isAuthenticated: true,
                user: action.payload.user,
                refreshTokenExp: action.payload.refreshTokenExp
            };
        case RECEIVE_USER_LOGOUT:
            return {
                isAuthenticated: false,
                user: undefined,
                refreshTokenExp: null
            };
        case UPDATE_USER_IMAGE:
            return {
                ...state,
                user: { ...state.user, image: action.user?.image }
            }
        default:
            return state;
    }
}